import { render } from "./RegiConsolForm.vue?vue&type=template&id=08de9e0f"
import script from "./RegiConsolForm.vue?vue&type=script&lang=js"
export * from "./RegiConsolForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__